import { Trans, useTranslation } from 'react-i18next';
import environment from '@environment';
import Checkbox from 'components/inputs/checkbox/checkbox';
import { SanitizeHTML } from 'shared/components/html-sanitizer';
import { Util } from 'utils/common.utils';
import styles from './../reward-details-card.module.scss';

function RewardDescription({
  label,
  endDate,
  bodyText,
  value,
  termsAndConditionsLink,
  // actionLink,
  onChecked,
  disabled,
  checked,
  isClaimed,
  claimedMessage,
}: {
  label: string;
  termsAndConditionsLink: { target?: string; name?: string; url?: string };
  bodyText: string;
  endDate?: Date;
  value?: number;
  onChecked: () => void;
  disabled: boolean;
  checked: boolean;
  isClaimed?: boolean;
  claimedMessage?: string;
}) {
  const { t } = useTranslation();
  return (
    <div>
      {label ? <img className={styles.rewardLabel} src={Util.GetMediaPath(label)} alt="reward_label" /> : null}
      <div className="text-regular text-dark-60 cust-pt-1 cust-mb-2">
        {isClaimed && claimedMessage ? (
          <SanitizeHTML html={`${claimedMessage}`} />
        ) : isClaimed ? (
          <Trans
            i18nKey="rewards.claim.reward.alreadyClaimed"
            defaults="<h5>Congratulations!</h5><p>View your inbox for more information on redeeming your reward.</p>"
            components={{
              h5: <h5 />,
              p: <p />,
              b: <b />,
            }}
          />
        ) : (
          <SanitizeHTML html={`${bodyText}`} />
        )}
      </div>
      {endDate ? (
        <p className="text-small text-dark-60 cust-mb-4">
          <Trans
            i18nKey="rewards.card.expires"
            defaults="Expires: {{endDate, datetime}}"
            values={{
              endDate,
              formatParams: {
                endDate: {
                  day: 'numeric',
                  month: 'long',
                  year: 'numeric',
                },
              },
            }}
          />
        </p>
      ) : undefined}
      {!disabled && termsAndConditionsLink?.url && termsAndConditionsLink?.url?.length > 1 ? (
        <>
          <p className="cust-mt-4 cust-mb-2 text-link text-small">
            <a target={termsAndConditionsLink?.target} href={termsAndConditionsLink?.url}>
              {termsAndConditionsLink?.name === '#'
                ? t('rewards.claim.competition.termsAndConditions')
                : termsAndConditionsLink?.name}
            </a>
          </p>
          <div className="cust-mb-4 d-flex align-items-center">
            <Checkbox
              id="enterCompetitionT&C"
              item={{
                id: 'enterCompetitionT&C',
                name: '',
                isChecked: checked,
              }}
              onChange={onChecked}
            />

            <span className="cursor-pointer" onClick={onChecked}>
              <Trans
                i18nKey="agreeTerms"
                values={{ link: environment.MULTICHOICE_TERM_AND_CONDITIONS_URL }}
                components={{
                  a: <a target="_blank" onClick={(event) => event.stopPropagation()} />,
                }}
              />
            </span>
          </div>
        </>
      ) : undefined}
    </div>
  );
}

export default RewardDescription;